"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeSlice = exports.sessionSlice = exports.setAdditionalDefaultHeaders = exports.LOCALE_LANG_KEY = exports.SESSION_KEY = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const flax_1 = require("@coralblack/flax");
const common_1 = require("../../consts/common");
// Set baseUrl
(0, flax_1.setBaseUrl)(process.env.REACT_APP_CDMS_URL || process.env.REACT_APP_CDMS_BE_URL || process.env.REACT_APP_SERVICE_HOST || "http://127.0.0.1");
exports.SESSION_KEY = "cream:auth";
exports.LOCALE_LANG_KEY = "LoLang";
const stored = localStorage.getItem(exports.SESSION_KEY);
const language = localStorage.getItem(exports.LOCALE_LANG_KEY);
const initialState = Object.assign({
    token: null,
    expiryAt: null,
}, stored ? JSON.parse(stored) : {});
const localeInitialState = Object.assign({ lolang: common_1.LoLang.KO }, language ? { lolang: language } : {});
const configurableDefaultHeaders = (headers) => Object.assign({
    Authorization: initialState.token,
    Lang: language || common_1.LoLang.KO,
    "Timezone-Offset": -new Date().getTimezoneOffset(),
}, headers || {});
(0, flax_1.setDefaultHeaders)(configurableDefaultHeaders());
const setAdditionalDefaultHeaders = (headers) => (0, flax_1.setDefaultHeaders)(headers);
exports.setAdditionalDefaultHeaders = setAdditionalDefaultHeaders;
exports.sessionSlice = (0, toolkit_1.createSlice)({
    name: "session",
    initialState,
    reducers: {
        signIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
            if (action.payload.redirectTo) {
                document.location.href = action.payload.redirectTo;
            }
            else {
                document.location.reload();
            }
        },
        signOut(state) {
            state.token = null;
            state.expiryAt = null;
            localStorage.removeItem(exports.SESSION_KEY);
            document.location.href = "/";
        },
        refreshSignIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
            (0, flax_1.setDefaultHeaders)(configurableDefaultHeaders({ Authorization: action.payload.authToken.token }));
        },
        updateExpiryAt(state, action) {
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
        },
    },
});
exports.localeSlice = (0, toolkit_1.createSlice)({
    name: "locale",
    initialState: localeInitialState,
    reducers: {
        changeLocaleLanguage(state, action) {
            state.lolang = action.payload.lolang;
            localStorage.setItem(exports.LOCALE_LANG_KEY, state.lolang);
        },
    },
});
//# sourceMappingURL=session.js.map